<div class="flex-table-page">
<div class="px-6 pt-6 flex-table-header">
  <h2 class="text-2xl font-semibold text-gray-800">
    {{ "e_invoice.history.title" | translate }}
  </h2>
</div>
<div class="px-6 py-4 flex flex-col flex-1 min-h-0">
  <!-- Search Form -->
  <app-search-form
    data-testid="e-invoice-history-search-form"
    [searchFormat]="searchFormConfig()"
    (formSearch)="onSearch($event)"
    (formReset)="onReset()"
  >
    <div slot="actions">
      <app-status-filter
        [primaryButton]="primaryButton"
        [secondaryButton]="secondaryButton"
        (secondaryButtonClick)="onColumnConfigClick($event)"
      ></app-status-filter>
    </div>
  </app-search-form>

  <!-- Data Table -->
  <div class="flex-table-section">
    <advanced-data-table
      data-testid="e-invoice-history-table"
      #advancedTable
      [dataSource]="dataSource()"
      [defaultColumns]="defaultColumns"
      [flexibleColumns]="flexibleColumns"
      [rows]="rows"
      [first]="first"
      [totalRecords]="totalRecords()"
      [loading]="loading()"
      [showInternalColumnConfigButton]="false"
      scrollHeight="flex"
      (pageChange)="onPageChange($event)"
    >
    <!-- Custom Template for Status, Currency, Date Columns -->
    <ng-template
      #customTemplate
      let-value
      let-column="column"
      let-rowData="rowData"
    >
      @if (column?.prop === "status") {
        <div class="flex items-center justify-center gap-1 w-full">
          <p-tag
            [attr.data-testid]="
              'e-invoice-history-status-tag-' + rowData.id
            "
            [value]="getStatusDisplayText(value)"
            [severity]="getStatusSeverity(value)"
            styleClass="status-tag"
          />
        </div>
      }

      @if (column?.prop === "taxSubmissionStatus") {
        <div class="flex items-center justify-center gap-1 w-full">
          <p-tag
            [attr.data-testid]="
              'e-invoice-history-tax-submission-status-tag-' + rowData.id
            "
            [value]="getTaxSubmissionDisplayText(value)"
            [severity]="getTaxSubmissionSeverity(value)"
            styleClass="status-tag"
          />
        </div>
      }

      @if (column?.prop === "paymentMethod") {
        <div class="text-left w-full">
          {{ getPaymentMethodDisplayText(value) }}
        </div>
      }

      @if (
        column?.prop === "totalAmount" ||
        column?.prop === "subtotal" ||
        column?.prop === "taxAmount" ||
        column?.prop === "discount"
      ) {
        <div class="text-right w-full">
          {{ formatCurrency(value) }}
        </div>
      }

      @if (column?.prop === "issuedDate") {
        <div class="text-center w-full">
          {{ formatDateTime(value) }}
        </div>
      }
    </ng-template>

    <!-- Custom Actions Template -->
    <ng-template #actionsTemplate let-rowData>
      <div class="flex items-center justify-center gap-2">
        @if (canView()) {
          <button
            [attr.data-testid]="'e-invoice-history-action-view-' + rowData.id"
            type="button"
            (click)="onView(rowData)"
            class="action-link action-view cursor-pointer"
          >
            {{ "common.actions.view" | translate }}
          </button>
        }
        @if (canView()) {
          <button
            [attr.data-testid]="
              'e-invoice-history-action-download-' + rowData.id
            "
            type="button"
            (click)="onDownload(rowData)"
            class="action-link action-download cursor-pointer"
          >
            {{ "e_invoice.history.actions.download" | translate }}
          </button>
        }
      </div>
    </ng-template>
    </advanced-data-table>
  </div>
</div>
</div>

<!-- Toast Messages -->
<p-toast data-testid="e-invoice-history-toast"></p-toast>

<!-- PDF Dialog -->
<p-dialog
  data-testid="e-invoice-history-pdf-dialog"
  [(visible)]="pdfDialogVisible"
  [header]="'common.actions.view' | translate"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  styleClass="invoice-preview-dialog"
  [style]="{ width: '80vw', height: '90vh' }"
  [contentStyle]="{ overflow: 'hidden', padding: 0, height: '100%' }"
  (onHide)="closePdfDialog()"
>
  @if (pdfLoading()) {
    <div
      class="flex items-center justify-center"
      style="height: calc(90vh - 60px)"
    >
      <div
        data-testid="e-invoice-history-pdf-loading"
        class="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-600"
      ></div>
    </div>
  } @else if (pdfUrl()) {
    <iframe
      data-testid="e-invoice-history-pdf-frame"
      [src]="pdfUrl()"
      class="w-full border-0"
      style="height: calc(90vh - 60px)"
    ></iframe>
  } @else {
    <div
      class="flex items-center justify-center"
      style="height: calc(90vh - 60px)"
    >
      <p class="text-gray-500">{{ "common.messages.error" | translate }}</p>
    </div>
  }
</p-dialog>
